import React from 'react';
import { useStartSocialOAuthMutation } from '../../../../models/graphql';
import { ApolloError } from '@apollo/client';
import { remapApolloErrors } from '../../../../helpers/remapApolloErrors';
import {
  SecondaryProfilesErrorModalController,
  SecondaryProfilesErrorModalControllerProps
} from './SecondaryProfilesErrorModal.controller';

export type SecondaryProfilesErrorModalApolloProps = Omit<
  SecondaryProfilesErrorModalControllerProps,
  'startSocialOAuth' | 'loading' | 'modalError'
> & {
  // apollo props
};

export const SecondaryProfilesErrorModalApollo = (props: SecondaryProfilesErrorModalApolloProps): JSX.Element => {
  const [startSocialOAuth, { error: startSocialError, loading: startSocialLoading }] = useStartSocialOAuthMutation({
    fetchPolicy: 'no-cache'
  });

  let modalError: string | JSX.Element = '';
  let loading = false;

  if (startSocialLoading) {
    loading = true;
    modalError = '';
  }
  if (startSocialError) {
    const errorForRemapping = startSocialError as ApolloError;
    modalError = remapApolloErrors(errorForRemapping);
    loading = false;
  }

  const args: SecondaryProfilesErrorModalControllerProps = {
    ...props,
    startSocialOAuth,
    loading,
    modalError
  };

  return <SecondaryProfilesErrorModalController {...args} />;
};
